module.exports = __webpack_public_path__ + "static/media/bg.e02ec0f1.jpg";